var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-5",attrs:{"outlined":""},on:{"click":e => _vm.$emit('click', e)}},[_c('div',{staticClass:"d-flex align-center pa-4"},[_c('v-card-title',{staticClass:"py-0 pr-0"},[_c('div',[_vm._v(_vm._s(_vm.tenant.name))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }